import Product from "@api/types/product";
import React, { FC, useState } from "react";

import BarsIcon from "@components/@atoms/bars-icon";
import GridIcon from "@components/@atoms/grid-icon";
import ProductCard from "@components/ProductCard";

const ProductCardGrid: FC<{ products: Product[] }> = ({ products }) => {
  const [toggleGrid, setToggleGrid] = useState(true);

  return (
    <>
      <div className="filters">
        <div />
        <div />
        <div />
        <div className="filters-layout">
          {toggleGrid ? (
            <BarsIcon
              width="24px"
              height="24px"
              color="currentColor"
              onClick={() => setToggleGrid(!toggleGrid)}
            />
          ) : (
            <GridIcon
              width="24px"
              height="24px"
              color="currentColor"
              onClick={() => setToggleGrid(!toggleGrid)}
            />
          )}
        </div>
      </div>
      <div className="ProductCardGrid">
        {products.map((p) => {
          return <ProductCard cy="product-card" key={p.id} product={p} grid={toggleGrid} />;
        })}
      </div>
      {/* language=CSS */}
      <style jsx>{`
        .ProductCardGrid {
          display: grid;
          grid-gap: 40px;
        }

        @media screen and (min-width: 768px) {
          .ProductCardGrid {
            grid-template-columns: ${toggleGrid ? "1fr" : "repeat(2, 1fr)"};
          }
        }

        @media screen and (min-width: 1024px) {
          .ProductCardGrid {
            grid-template-columns: ${toggleGrid ? "1fr" : "repeat(3, 1fr)"};
          }
        }

        .filters {
          display: grid;
          grid-template-columns: 6fr 3fr 3fr 1fr;
          grid-column-gap: 8px;
          padding-bottom: 1em;
          margin-bottom: 2em;
          border-bottom: 1px solid #ebebeb;
        }

        .filters-layout {
          margin: auto auto;
        }
      `}</style>
    </>
  );
};

export default ProductCardGrid;
